import { render, staticRenderFns } from "./StrapiPagination.vue?vue&type=template&id=5d6f8778&scoped=true&"
import script from "./StrapiPagination.vue?vue&type=script&lang=js&"
export * from "./StrapiPagination.vue?vue&type=script&lang=js&"
import style0 from "./StrapiPagination.vue?vue&type=style&index=0&id=5d6f8778&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6f8778",
  null
  
)

export default component.exports